
export default function Products() {
  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="bg-gray-900 rounded-[32px] h-[600px] p-10 flex flex-col justify-between relative overflow-hidden group transition-transform hover:-translate-y-2 cursor-pointer">
            <div className="absolute bottom-0 right-0 w-64 h-64 opacity-20">
              <svg viewBox="0 0 200 200" fill="none">
                <circle cx="100" cy="100" r="80" stroke="url(#gradient1)" strokeWidth="2" />
                <circle cx="100" cy="100" r="60" stroke="url(#gradient1)" strokeWidth="2" />
                <circle cx="100" cy="100" r="40" stroke="url(#gradient1)" strokeWidth="2" />
                <line x1="100" y1="20" x2="100" y2="180" stroke="url(#gradient1)" strokeWidth="1" />
                <line x1="20" y1="100" x2="180" y2="100" stroke="url(#gradient1)" strokeWidth="1" />
                <defs>
                  <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#0066FF" />
                    <stop offset="100%" stopColor="#00CCFF" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            
            <div>
              <div className="w-20 h-20 bg-gray-800 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-5xl font-normal text-white mb-4">VPN Protection</h3>
              <p className="text-gray-400 text-base">Secure connection for your privacy</p>
            </div>
          </div>

          <div 
            className="rounded-[32px] h-[680px] relative overflow-hidden group transition-transform hover:-translate-y-2 cursor-pointer"
            style={{ marginTop: '-60px' }}
          >
            <div 
              className="absolute inset-0"
              style={{
                backgroundImage: `url(https://public.readdy.ai/ai/img_res/87071204ffdfc18b1958b4d9d2beb06b.jpg)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            ></div>
            <div className="absolute inset-0 bg-black/40"></div>
            
            <div className="absolute top-8 left-8">
              <div className="bg-black/60 backdrop-blur-md rounded-full px-6 py-3 flex items-center space-x-2">
                <i className="ri-flashlight-line text-white text-sm"></i>
                <span className="text-white text-sm font-light">Optimization</span>
              </div>
            </div>
            
            <div className="absolute bottom-10 left-10">
              <h3 className="text-5xl font-normal text-white">Device Cleaner</h3>
            </div>
          </div>

          <div className="bg-white rounded-[32px] h-[620px] p-10 flex flex-col justify-between border border-gray-200 group transition-transform hover:-translate-y-2 cursor-pointer">
            <div>
              <h3 className="text-4xl font-normal text-gray-900 mb-4 font-serif">Advanced Technology</h3>
              <p className="text-sm text-gray-500 font-light">Built with cutting-edge iOS frameworks</p>
            </div>
            
            <div className="mt-8">
              <img
                src="https://readdy.ai/api/search-image?query=abstract-technical-visualization-showing-swift-code-snippets-with-blue-accent-lighting-modern-programming-interface-dark-theme-professional-developer-workspace-clean-minimalist-composition&width=400&height=300&seq=tech-viz-001&orientation=landscape"
                alt="Technology Visualization"
                className="w-full h-64 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}